<template>
  <PSIndex />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
